/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowRuleList {
    getFixupPrototypeFunction() { return WorkFlowRuleList.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowRuleList>): WorkFlowRuleList {
        let obj = Object.assign(new WorkFlowRuleList(), model);
        WorkFlowRuleList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowRuleList>): WorkFlowRuleList {
        if (!model) return null;
        return WorkFlowRuleList.newInstance(<WorkFlowRuleList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowRuleList) {
        if (!obj) return;

        models.WorkFlowRuleList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowRuleList): boolean {
        Object.setPrototypeOf(obj, WorkFlowRuleList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.rules) {
            for (let val of this.rules) {
                models.WorkFlowRuleDetailBase.fixupPrototype(val);
            }
        }
    }

    /**
     * The list of workflow rules.
     */
    rules: Array<models.WorkFlowRuleDetailBase>;

}
